// extracted by mini-css-extract-plugin
export var divider = "_fi-7";
export var itemsToggle = "_fi-8";
export var mergeModal = "_fi-1";
export var optionCard = "_fi-4";
export var radioGroup = "_fi-6";
export var radioOption = "_fi-0";
export var selected = "_fi-5";
export var shipmentOptions = "_fi-2";
export var tableOptions = "_fi-3";